import {BrowserRouter as Router, Routes, Route} from 'react-router-dom';
import React, { useState , useEffect , Suspense } from 'react';
import Loading from './Loading';
import {auth} from './providers/firebase';
import {onAuthStateChanged} from 'firebase/auth';
import PrivateRoute from './providers/PrivateRoute';
import {Navigate} from 'react-router-dom';
import './App.css';
/* GameFiles */
const Char = React.lazy(() => import('./components/game/Char'));
const Layout = React.lazy(() => import('./components/layout/Layout'));
const News = React.lazy(() => import('./components/game/News'));
const Items = React.lazy(() => import('./components/game/Items'));
const Castle = React.lazy(() => import('./components/game/Castle'));
const Shop = React.lazy(() => import('./components/game/Shop'));
const Battle = React.lazy(() => import('./components/battle/Battle'));
/* HomeFiles */
import Register from './components/home/Register';
import VerifyEmail from './components/home/VerifyEmail';
import Login from './components/home/Login';
import {AuthProvider} from './providers/AuthContext';

function App() {

  const [currentUser, setCurrentUser] = useState(null)
  const [timeActive, setTimeActive] = useState(false)

  useEffect(() => {
    onAuthStateChanged(auth, (user) => {
      setCurrentUser(user)
    })
  }, [])

  return (
    <Router>
      <Suspense fallback={<div style={{"loader":{"background":"radial-gradient(#222, #000)","bottom":"0","left":"0","overflow":"hidden","position":"fixed","right":"0","top":"0","zIndex":"99999"},"loader_inner":{"bottom":"0","height":"60px","left":"0","margin":"auto","position":"absolute","right":"0","top":"0","width":"100px"},"loader_line_wrap":{"animation":"spin 2000ms cubic-bezier(.175, .885, .32, 1.275) infinite","boxSizing":"border-box","height":"50px","left":"0","overflow":"hidden","position":"absolute","top":"0","transformOrigin":"50% 100%","width":"100px"},"loader_line":{"border":"4px solid transparent","borderRadius":"100%","boxSizing":"border-box","height":"100px","left":"0","margin":"0 auto","position":"absolute","right":"0","top":"0","width":"100px"},"loader_line_wrap_nth_child_1":{"animationDelay":"-25ms"},"loader_line_wrap_nth_child_2":{"animationDelay":"-50ms"},"loader_line_wrap_nth_child_3":{"animationDelay":"-75ms"},"loader_line_wrap_nth_child_4":{"animationDelay":"-100ms"},"loader_line_wrap_nth_child_5":{"animationDelay":"-125ms"},"loader_line_wrap_nth_child_1___loader_line":{"borderColor":"hsl(0, 80%, 60%)","height":"90px","width":"90px","top":"7px"},"loader_line_wrap_nth_child_2___loader_line":{"borderColor":"hsl(60, 80%, 60%)","height":"76px","width":"76px","top":"14px"},"loader_line_wrap_nth_child_3___loader_line":{"borderColor":"hsl(120, 80%, 60%)","height":"62px","width":"62px","top":"21px"},"loader_line_wrap_nth_child_4___loader_line":{"borderColor":"hsl(180, 80%, 60%)","height":"48px","width":"48px","top":"28px"},"loader_line_wrap_nth_child_5___loader_line":{"borderColor":"hsl(240, 80%, 60%)","height":"34px","width":"34px","top":"35px"}}} ><div className="loader"><div className="loader-inner"><div className="loader-line-wrap"><div className="loader-line"></div></div><div className="loader-line-wrap"><div className="loader-line"></div></div><div className="loader-line-wrap"><div className="loader-line"></div></div><div className="loader-line-wrap"><div className="loader-line"></div></div><div className="loader-line-wrap"><div className="loader-line"></div></div></div></div></div>}>
      <AuthProvider value={{currentUser, timeActive, setTimeActive}}>
        <Routes>
          {/* private routes */}
          <Route element={<PrivateRoute />}>
            <Route element={<Layout user={currentUser} />}>
              <Route exact path='/' element={<News/>}/>
              <Route exact path='/char' element={<Char />}/>
              <Route exact path='/items' element={<Items />}/>
              <Route exact path='/castle' element={<Castle />}/>
              <Route exact path='/arena' element={<News/>}/>
              <Route exact path='/palast' element={<News/>}/>
              <Route exact path='/shop' element={<Shop />}/>
              <Route exact path='/marketplace' element={<News/>}/>
              <Route exact path='/leaderboard' element={<News/>}/>
              <Route exact path='/battle' element={<Battle/>}/>
            </Route>
          </Route>
          {/* <Route exact path="/char" element={<PrivateRoute><Char/></PrivateRoute>} /> */}
          {/* public routes */}
          <Route path="/login" element={
            !currentUser?.emailVerified 
            ? <Login/>
            : <Navigate to='/' replace/>
          } />
          
          <Route path="/register" element={
            !currentUser?.emailVerified 
            ? <Suspense fallback={<div>Loading..</div>}><Register/></Suspense>
            : <Navigate to='/' replace/>
          } />
          <Route path="/verify-email" element={
            currentUser 
            ? <VerifyEmail/>
            : <Navigate to='/' replace/>
          } />
          {/* when nothing fits */}
          <Route path="*"
            element={
              <main style={{ padding: "1rem" }}>
                <p>There's nothing here!</p>
              </main>
            }
          />
        </Routes>  
      </AuthProvider>
      </Suspense>
  </Router>
  );
}

export default App;
